<template>
    <div class="v-promo__boxes">
        <div class="row">
            <div class="col-md-6 col-lg-4">
                <h3 class="typo typo--headline mb-3" v-text="'Szczegóły'" />

                <div class="tr-data is-column">
                    <div class="tr-data__cell" v-if="promotion.locked_at">
                        <span
                            class="tr-data__dt"
                            v-text="'Aktywacja możliwa do'"
                        />

                        <span class="tr-data__dd">
                            {{ $moment(promotion.locked_at).format('DD.MM.YYYY, HH:mm') }}
                        </span>
                    </div>

                    <div class="tr-data__cell">
                        <span
                            class="tr-data__dt"
                            v-text="'Czas trwania promocji'"
                        />

                        <span class="tr-data__dd">
                            {{ durationDays | plurals('dzień', 'dni') }}
                        </span>
                    </div>

                    <div class="tr-data__cell">
                        <span class="tr-data__dt">{{ daysLeft.countText }}</span>

                        <span class="tr-data__dd" v-text="daysLeft.diff" />
                    </div>
                    <div v-if="promotion.type !== PROMO_TYPES.SALES_TARGET" class="border-top">
                        <div class="tr-data__cell">
                            <span
                                class="tr-data__dt"
                                v-text="usageLimitPerReceiptLabelText"
                            />

                            <span
                                class="tr-data__dd"
                                v-text="usageLimitPerReceiptValue"
                            />
                        </div>
                        <div class="tr-data__cell">
                            <span
                                class="tr-data__dt"
                                v-text="'Limit użyć na sklep'"
                            />

                            <span class="tr-data__dd">
                                {{
                                    promotion.usage_limit_per_location
                                        ? promotion.usage_limit_per_location
                                        : '-'
                                }}
                            </span>
                        </div>

                        <div v-if="promotion.loyalty" class="tr-data__cell">
                            <span
                                class="tr-data__dt"
                                v-text="'Limit użyć na kartę'"
                            />

                            <span class="tr-data__dd">
                                {{
                                    promotion.usage_limit_per_loyalty_card
                                        ? Number(promotion.usage_limit_per_loyalty_card)
                                        : '-'
                                }}
                            </span>
                        </div>

                        <div v-if="promotion.loyalty" class="tr-data__cell">
                            <span
                                class="tr-data__dt"
                                v-text="'Limit użyć na kartę (dzienny)'"
                            />

                            <span class="tr-data__dd">{{
                                promotion.usage_limit_per_loyalty_card_daily
                                    ? Number(promotion.usage_limit_per_loyalty_card_daily)
                                    : '-'
                            }}</span>
                        </div>

                        <div class="tr-data__cell">
                            <span class="tr-data__dt" v-text="'Priorytet'" />

                            <span class="tr-data__dd" v-text="promotion.priority" />
                        </div>
                        <div class="tr-data__cell tr-data__cell--text">
                            <span
                                class="tr-data__dt"
                                v-text="'Tekst na paragonie'"
                            />

                            <span
                                class="tr-data__dd"
                                v-html="promotion.discount_text"
                            />
                        </div>
                    </div>
                    <div v-else-if="promotion.type === PROMO_TYPES.SALES_TARGET" class="border-top">
                        <div
                            v-for="(threshold, idx) in promotion.salesTargetThresholds"
                            class="tr-data__cell"
                            :key="`threshold-${idx}`"
                        >
                            <span class="tr-data__dt">
                                Próg {{ ++idx }} (nagroda)
                            </span>
                            <span class="tr-data__dd">
                                {{ threshold.target }} szt.
                                ({{ threshold.prize_amount | currency(promotion.type) }})
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <promotion-actions
                v-if="showPromoActions"
                class="col-md-6 col-lg-4 mt-5 mt-lg-0"
                :promotion="promotion"
                :deselect-all="deselectAll"
                :accept-promos="acceptPromos"
                :is-locked="isLocked"
            />

            <div class="col-lg-4 mt-5 mt-lg-0" style="padding-top: 2.5rem">
                <promotion-slider
                    v-if="promotion.attachments && promotion.attachments.length"
                    :data="attachmentsMap"
                />
            </div>
            <div class="v-promo__mobile-infographic">
                <infographic :infographic="promotion.infographic" />
            </div>
        </div>
    </div>
</template>

<script>
import { PROMO_TYPES } from '@/utils/constants/promo-types'
import Infographic from '@/components/promotion/Infographic'
import PromotionSlider from '@/components/promotions/PromotionSlider'
import PromotionActions from './Actions.vue'

export default {
    props: {
        promotion: {
            type: Object,
            required: true
        },

        deselectAll: {
            type: Function,
            required: true
        },

        acceptPromos: {
            type: Function,
            required: true
        },

        isLocked: {
            type: Boolean,
            default: false
        }
    },

    components: {
        PromotionActions,
        PromotionSlider,
        Infographic
    },

    created() {
        this.PROMO_TYPES = PROMO_TYPES
    },

    computed: {
        durationDays() {
            const start = this.$moment(this.promotion.start_at).set({
                h: 0,
                m: 1,
                s: 0
            })
            const end = this.$moment(this.promotion.end_at).set({
                h: 23,
                m: 59,
                s: 0
            })
            return Math.ceil(end.diff(start, 'days', true))
        },

        daysLeft() {
            return this.$store.getters.getDaysLeft(this.promotion)
        },

        isWeightTypePromo() {
            return this.$store.getters.isWeight(this.promotion.type)
        },

        usageLimitPerReceiptLabelText() {
            return this.isWeightTypePromo
                ? 'Limit kg na paragon'
                : 'Limit użyć na paragonie'
        },

        usageLimitPerReceiptValue() {
            let usageLimitPerReceipt = this.promotion.usage_limit_per_receipt
            if (usageLimitPerReceipt && this.isWeightTypePromo) {
                usageLimitPerReceipt = usageLimitPerReceipt.toFixed(3)
            }
            return usageLimitPerReceipt || '-'
        },

        showPromoActions() {
            return this.$store.getters.isPromoEditPermission
        },

        isSuspended() {
            return this.promotion.subscriptions.every(
                el => el.suspended === true
            )
        },

        attachmentsMap() {
            return this.promotion.attachments.map(e => {
                return {
                    urls: {
                        original: e.urls.original
                    },
                    fileName: e.name,
                    name: e.name
                }
            })
        }
    }
}
</script>
